/* -------------------- i18n messages for RBC -------------------- */
export const RBC_MESSAGES = {
  en: {
    date: 'Date',
    time: 'Time',
    event: 'Event',
    allDay: 'All Day',
    week: 'Week',
    work_week: 'Work Week',
    day: 'Day',
    month: 'Month',
    previous: 'Back',
    next: 'Next',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    today: 'Today',
    agenda: 'Agenda',
    noEventsInRange: 'No events in this range.',
    showMore: (total: number) => `+${total} more`,
  },
  ru: {
    date: 'Дата',
    time: 'Время',
    event: 'Событие',
    allDay: 'Весь день',
    week: 'Неделя',
    work_week: 'Рабочая неделя',
    day: 'День',
    month: 'Месяц',
    previous: 'Назад',
    next: 'Вперёд',
    yesterday: 'Вчера',
    tomorrow: 'Завтра',
    today: 'Сегодня',
    agenda: 'Повестка',
    noEventsInRange: 'Нет событий в этом диапазоне.',
    showMore: (total: number) => `+${total} ещё`,
  },
};

/* -------------------- Forced weekday short labels -------------------- */
export const WEEKDAY_SHORT: Record<string, string[]> = {
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
};

/* -------------------- Event Type Colors -------------------- */
export const EVENT_STYLES = {
  FIRM_EVENT: {
    className: 'calendar-event-firm-event',
    dotColor: 'bg-emerald-500',
    badgeVariant: 'outline' as const,
  },
  NEW_CLIENT: {
    className: 'calendar-event-new-client',
    dotColor: 'bg-sky-500',
    badgeVariant: 'outline' as const,
  },
  CASE_MEETING: {
    className: 'calendar-event-case-meeting',
    dotColor: 'bg-violet-500',
    badgeVariant: 'outline' as const,
  },
};

export const EVENT_COLORS = {
  FIRM_EVENT: { bg: '#d1fae5', text: '#065f46', border: '#10b981' },
  NEW_CLIENT: { bg: '#e0f2fe', text: '#075985', border: '#0284c7' },
  CASE_MEETING: { bg: '#f5f3ff', text: '#6d28d9', border: '#8b5cf6' },
};

export interface BigCalendarEvent {
  id: number;
  title: string;
  description: string;
  color: string;
  start: Date;
  end: Date;
  target?: string;
  matterName?: string;
  clientName?: string;
}
